import { FC } from 'react';
import { getBadgeClass, formatBadgeLabel } from '@lib/badge-color';

interface BadgeProps {
  status?: string | boolean;
  label?: string;
  icon?: React.ReactNode;
  className?: string;
}

const Badge: FC<BadgeProps> = ({ status, label, icon, className = '' }) => {
  const displayLabel = label || formatBadgeLabel(status);
  const baseClass = getBadgeClass(status);

  return (
    <span className={`${baseClass} ${className}`}>
      {icon && <span>{icon}</span>}
      <span className="uppercase">{displayLabel}</span>
    </span>
  );
};

export default Badge;
